import React, {useEffect, useState, useRef} from 'react'
import glidify from '../../../../scripts/dom/glidify'


interface RVData  {
  handle: string;
  productData: {
    image: string,
    title: string
  }
}

interface RecentlyViewedProps {
  dataSet: {
    handle: string,
    image: string,
    title: string,
    limit: string,
    langStrings: string
  }
}

const getRecentlyViewedFromStorage = () => {
  const data = window.localStorage.getItem('blubolt:recentlyViewed');
  if (!data) {
    return {}
  }
  return JSON.parse(data)
}
const setRecentlyViewedInStorage = (limit: number) => ({ handle, productData }: RVData): void => {
  const data = Object.entries({ ...{ [handle]: productData }, ...getRecentlyViewedFromStorage() })
    .slice(0, limit + 1)
    .reduce((d, [key, val]) => ({ ...d, ...{ [key]: val } }), {})
  window.localStorage.setItem('blubolt:recentlyViewed', JSON.stringify(data))
}

const RecentlyViewed: React.FunctionComponent<RecentlyViewedProps> = ({ dataSet } : RecentlyViewedProps) => {
  const {handle, image, title, limit, langStrings} = dataSet
  const [recentlyViewed, setRecentlyViewed] = useState({[handle]: {image, title}});
  const setRecentlyViewedInStorageWithLimit = setRecentlyViewedInStorage(parseInt(limit))
  const container = useRef(null)
  const prods = Object.entries(recentlyViewed).filter(([prodHandle]) => prodHandle !== handle)

  const [rvLangStrings, setRvLangLangStrings] = useState({} as Record<string, string>)

  const [initialised, setInitialised] = useState(false)

  useEffect(() => {
    let parsedLangsStrings = {}
    try {
      parsedLangsStrings = JSON.parse(langStrings)
    } catch (e) {
      console.info(e)
    }
    setRvLangLangStrings(parsedLangsStrings)
  }, [])
  
  const { heading } = rvLangStrings;




  useEffect(() => {
    if (handle && image && title) {
      setRecentlyViewedInStorageWithLimit({ handle, productData: { image, title } })
    }
    setRecentlyViewed(getRecentlyViewedFromStorage())

  }, [])

  useEffect(() => {
    if (!initialised && prods.length > 1) {
      glidify(container.current)
      setInitialised(true)
    }
  }, [prods])

  const glideConfig = { perView:4, type: 'carousel', breakpoints:{ 768: { perView: 2.2 }}}

  if (prods.length < 1) {
    return <></>
  }
  return (
    <div className="relative">
      <h3 className="heading-4">{ heading }</h3>
      <hr className="separator"></hr>
      <div ref={container}>
        <div data-glide data-glide-id="recently-viewed" data-glider-config={JSON.stringify(glideConfig)}>
          <div  data-glide-el="controls">
            <button className="glide-next" data-glide-dir="<"><span className="sr-only">Next</span></button>
            <button className="glide-prev" data-glide-dir=">"><span className="sr-only">Previous</span></button>
          </div>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides recently-viewed">
              { prods.map(([prodHandle, prodData]) => {
                return (
                  <li className="recently-viewed-prod glide__slide" key={prodHandle}>
                    <a href={`/products/${prodHandle}`}>
                      <div className="recently-viewed-prod-image">
                        <img src={ decodeURI(prodData.image) } alt={prodData.title}/>
                      </div>
                      <h4 className="recently-viewed-prod-title">{prodData.title}</h4>
                    </a>
                  </li>
                )
              }) }
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
};

export default RecentlyViewed
